import React from 'react';

interface OwlShellSiderState {
  siderWidth: number;
}

interface OwlShellSiderHandler {
  expand(): void;
  collapse(): void;
}

export const DEFAULT_WIDTH = 80;

const useOwlShellSider = (): [OwlShellSiderState, OwlShellSiderHandler] => {
  const [siderWidth, setSiderWidth] = React.useState(DEFAULT_WIDTH);

  const handler = React.useMemo(
    () => ({
      expand: () => {
        setSiderWidth(240);
      },
      collapse: () => {
        setSiderWidth(DEFAULT_WIDTH);
      },
    }),
    []
  );

  return [{ siderWidth }, handler];
};

export default useOwlShellSider;
